import { useEffect, useState } from "react";
import axios from "axios";
import { KeyRound, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function LeadsPage() {
  const [key, setKey] = useState(sessionStorage.getItem("ims-leads-key") || "");
  const [leads, setLeads] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (k) => {
    if (!k) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/leads`, { params: { key: k } });
      setLeads(res.data.leads);
      sessionStorage.setItem("ims-leads-key", k);
      setError("");
    } catch {
      setLeads(null);
      sessionStorage.removeItem("ims-leads-key");
      setError("Incorrect passcode. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (key) load(key); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!leads) {
    return (
      <section className="leads-page" data-testid="leads-gate">
        <div className="leads-gate">
          <span className="eyebrow">Private</span>
          <h1>Enquiries inbox.</h1>
          <p>Enter your passcode to view every enquiry received through the website.</p>
          <form onSubmit={(e) => { e.preventDefault(); load(key); }}>
            <input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder="Passcode" data-testid="leads-passcode-input" />
            {error && <div className="leads-error" data-testid="leads-error-message">{error}</div>}
            <button type="submit" className="button leads-unlock" data-testid="leads-unlock-button"><KeyRound size={16} /> View enquiries</button>
          </form>
        </div>
      </section>
    );
  }

  return (
    <section className="leads-page" data-testid="leads-inbox">
      <div className="leads-head">
        <div>
          <span className="eyebrow">Private</span>
          <h1>Enquiries inbox.</h1>
        </div>
        <button className="leads-refresh" onClick={() => load(key)} data-testid="leads-refresh-button"><RefreshCw size={15} /> Refresh</button>
      </div>
      <p className="leads-count" data-testid="leads-count">{leads.length} enquir{leads.length === 1 ? "y" : "ies"} received</p>
      <div className="leads-scroll">
        <table className="lead-table" data-testid="leads-table">
          <thead>
            <tr><th>When</th><th>Name</th><th>You are</th><th>Phone</th><th>City</th><th>Message</th></tr>
          </thead>
          <tbody>
            {leads.map((lead, i) => (
              <tr key={i} data-testid={`lead-row-${i}`}>
                <td>{new Date(lead.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</td>
                <td><b>{lead.name}</b></td>
                <td>{lead.role || "—"}</td>
                <td>{lead.phone}</td>
                <td>{lead.city}</td>
                <td>{lead.message || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
